import { Container, Grid, Typography, Avatar } from "@material-ui/core";
import moment from "moment";
//STYLES
import useStyles from "./style"; 

export default function BlogHeader(props){

  const {title, subtitle, authorName, date, coverImage,} = props;
  const classes = useStyles();
  return (
    <Container className={classes.root}>
      <Grid container direction="column" spacing={3}>
        <Grid item>
          <Typography variant="h1">{title}</Typography>
        </Grid>
        <Grid item container wrap="nowrap" alignItems="center" spacing={3}>
          <Grid item>
            <Avatar
              aria-label="avator image"
              className={classes.avatar}
              src={'/images/logo512.png'} //authorImage
            />
          </Grid>
          <Grid item container direction="column">
            <Grid item>
              <Typography>{authorName}</Typography>
            </Grid>
            <Grid item>
              <Typography color="textSecondary">
                {moment(date).format("MMMM Do YYYY").toUpperCase()}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <img src={coverImage} className={classes.coverImage} />
        </Grid>
        <Grid item>
          <Typography variant="h2">{subtitle}</Typography>
        </Grid>
      </Grid>
    </Container>
  );
}